<ion-app>
  <ion-split-pane when="xl" content-id="main-content">
    <ion-menu
      content-id="main-content"
      type="overlay"
      [disabled]="!global.isLoggedIn"
      >
      <ion-header>
        <ion-toolbar>
          <ion-title>Lisaas App</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content id="my-content">
        <ion-list>
          @for (p of appPages; track p) {
            <ion-menu-toggle
              auto-hide="false"
              >
              @if (!p.hide) {
                <ion-item
                  routerDirection="root"
                  [routerLink]="[p.url]"
                  lines="none"
                  detail="false"
                  routerLinkActive="selected"
                  (click)="p.click ? p.click() : null"
                  >
                  <ion-icon slot="start" [name]="p.icon"></ion-icon>
                  <ion-label>
                    {{ p.title }}
                  </ion-label>
                </ion-item>
              }
            </ion-menu-toggle>
          }
        </ion-list>
      </ion-content>
      <!-- ? profile swticher -->
      @if (global.isLoggedIn) {
        <ion-footer>
          <ion-toolbar>
            <ion-item
              button
                        (click)="
                            global?.profileManagementEnabled &&
                                openProfileSwitcher()
                        "
              lines="none"
              >
              <ion-avatar slot="start" color="primary">
                <div class="avatar-initials">
                  {{ global.username?.charAt(0).toUpperCase() }}
                </div>
              </ion-avatar>
              <ion-label>
                <h2>{{ global.username }}</h2>
                <p>{{ global.compname }}</p>
              </ion-label>
            </ion-item>
          </ion-toolbar>
        </ion-footer>
      }
      <!-- ? profile swticher -->
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
